import { createSlice } from "@reduxjs/toolkit";



let initialState = {
    screenerType: 'Screener',
    prevtab: null,
    PeersetName: "",
    PeersetType: "My",
    selectedUserPeersetName: [],
    radiobuttonaggregate: "Non-Aggregate",
    selectedUserPeersetData: [],
    SelectedfieldConsolidate: 'S',
    selectedUserPeersetDataNonAgg: [],
    addSelectedFilterdata: [],
    tblOpt: 'Table',
    selectedPeersetDropdown: "",
    nodeName: "General",
    formulaType: '',
    showGetapi: '',
    customRow: false,
}

export const commonslice = createSlice({
    name: "commonredux",
    initialState,
    reducers: {
        setselectedtab: (state, action) => {
            state.selectedtab = action.payload
        },
        setScreenerType: (state, action) => {
            state.screenerType = action.payload
        },
        setPrevselectedtab: (state, action) => {
            state.prevtab = action.payload
        },
        setCustomRow: (state, action) => {
            state.customRow = action.payload
        },
        setShowGetAPi: (state, action) => {
            state.showGetapi = action.payload
        },
        setradiobuttonaggregate: (state, action) => {
            state.radiobuttonaggregate = action.payload
        },
        setSelectedUserPeersetName: (state, action) => {
            state.selectedUserPeersetName = action.payload;
        },
        setPeersetName: (state, action) => {
            state.PeersetName = action.payload;
        },
        setPeersetType: (state, action) => {
            state.PeersetType = action.payload;
        },
        setSelectedUserPeersetData: (state, action) => {
            state.selectedUserPeersetData = action.payload;
        },
        removeUserPeersetData: (state, action) => {
            const itemId = action.payload.uniqueId;

            state.selectedUserPeersetData = state.selectedUserPeersetData.filter(
                (item) => item.uniqueId !== itemId
            );
        },
        setSelectedUserPeersetDataNonAgg: (state, action) => {
            state.selectedUserPeersetDataNonAgg = action.payload;
        },
        setSelectedfieldConsolidate: (state, action) => {
            state.SelectedfieldConsolidate = action.payload
        },
        DeleteSelectedfieldConsolidate: (state, action) => {
            state.SelectedfieldConsolidate = ""
        },
        resetSelectedFilterData: (state) => {
            state.addSelectedFilterdata = [];
        },
        settblOpt: (state, action) => {
            state.tblOpt = action.payload
        },
        // setAddSelectedFilterdata: (state, action) => {
        //     state.addSelectedFilterdata = [...state.addSelectedFilterdata, action.payload];
        // },
        setAddSelectedFilterdata: (state, action) => {
            const newRow = action.payload;

            // Check if the row already exists in the state
            const exists = state.addSelectedFilterdata.some(
                (item) => item.ScreenName === newRow.ScreenName && item.DisplayName === newRow.DisplayName
            );

            if (!exists) {
                state.addSelectedFilterdata.push(newRow);
            }
        },
        removeSelectedFilterdata: (state, action) => {
            const { ScreenName, DisplayName } = action.payload;
            state.addSelectedFilterdata = state.addSelectedFilterdata.filter(
                (item) => !(item.ScreenName === ScreenName && item.DisplayName === DisplayName)
            );
        },
        setSelectedPeersetDropdown: (state, action) => {
            state.selectedPeersetDropdown = action.payload
        },
        setNodeName: (state, action) => {
            state.nodeName = action.payload
        },
        setFormulaType: (state, action) => {
            state.formulaType = action.payload
        }
    }
})

export default commonslice.reducer;
export const {
    setselectedtab,
    setScreenerType,
    setPrevselectedtab,
    setCustomRow,
    setradiobuttonaggregate,
    setSelectedUserPeersetName,
    setSelectedUserPeersetData,
    removeUserPeersetData,
    setSelectedUserPeersetDataNonAgg,
    setSelectedfieldConsolidate,
    DeleteSelectedfieldConsolidate,
    resetSelectedFilterData,
    setPeersetName,
    setPeersetType,
    settblOpt,
    setAddSelectedFilterdata,
    removeSelectedFilterdata,
    setSelectedPeersetDropdown,
    setNodeName,
    setShowGetAPi,
    setFormulaType
} = commonslice.actions;
